import React, { Children } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import AddCircle from '@material-ui/icons/AddCircle';
import { NavLink } from 'react-router-dom';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import _ from 'lodash';
import { connect } from 'react-redux';
import { resourceMap, styles } from '../shared/imports';

class BarredView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			list: [],
			filteredList: [],
			showPrevious: false,
		};
	}

	componentDidMount() {
		this.getList();
	}

	getList = () => {
		fetch('/api/barredList')
			.then(res => res.json())
			.then(list => this.setState({ list: list, filteredList: list }));
	};

	displayPerson = person => {
		return (
			<div>
				<a style={{ color: '#000', fontWeight: 'bold' }} href={'/barredAdd/' + person._id}>
					{person.first_name} {person.last_name} {!person.indefinate && <span>{moment(person.expires).format('YYYY-MM-DD')}</span>}
					<br />
					<img src={person.pic} width="200" />
				</a>
			</div>
		);
	};

	togglePrevious = () => {
		this.setState({ showPrevious: !this.state.showPrevious });
	};

	filter = event => {
		const searchValue = event.target.value;
		if (searchValue === '') this.setState({ filteredList: this.state.list });
		else {
			console.log('search:', searchValue);
			this.setState({
				filteredList: this.state.list.filter(name => {
					return name.first_name.toLowerCase().includes(searchValue.toLowerCase());
				}),
			});
		}
	};

	render() {
		const items = this.state.list;
		const { classes } = this.props;
		const itemStyle = {
			display: 'flex',
			gap: '10px',
		};
		let id = '';
		return (
			<div>
				<div id="search">
					Search: <input name="search" onChange={this.filter} />
				</div>

				<h1 className={classes.h1}>Temporarily Barred</h1>
				{this.state.filteredList.length && (
					<div style={itemStyle}>
						{this.state.filteredList.map(person => {
							if (!person.indefinate && moment(person.expires).isAfter(moment())) return this.displayPerson(person);
						})}
					</div>
				)}
				<br />
				<br />
				<h1 className={classes.h1}>Indefinately Barred</h1>
				{this.state.filteredList.length && (
					<div style={itemStyle}>
						{this.state.filteredList.map(person => {
							if (person.indefinate) return this.displayPerson(person);
						})}
					</div>
				)}
				<br />
				<h1 className={classes.h1} onClick={this.togglePrevious}>
					{this.state.showPrevious ? <span>Hide</span> : <span>Show</span>} Previously Barred
				</h1>

				{this.state.filteredList.length && this.state.showPrevious && (
					<div style={itemStyle}>
						{this.state.filteredList.map(person => {
							if (!person.indefinate && moment(person.expires).isBefore(moment())) return this.displayPerson(person);
						})}
					</div>
				)}
			</div>
		);
	}
}
//this can be a calendar prop
//onSelectEvent={event => alert(event.title)}
const ViewBarred = withStyles(styles, { withTheme: true })(BarredView);
export default ViewBarred;
